export class BillingTransactionHistory {
    'id';
    'marketplaceAccountId';
    'usedCredits';
    'eonUsage';
    'addedCredits';
    'costUnit';
    'transactionType';
    'marketplaceAgreementId';
    'marketplaceRefundId';
    'billingTime';
    'cloudProvider';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "marketplaceAccountId",
            "baseName": "marketplaceAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "usedCredits",
            "baseName": "usedCredits",
            "type": "number",
            "format": "double"
        },
        {
            "name": "eonUsage",
            "baseName": "eonUsage",
            "type": "number",
            "format": "double"
        },
        {
            "name": "addedCredits",
            "baseName": "addedCredits",
            "type": "number",
            "format": "double"
        },
        {
            "name": "costUnit",
            "baseName": "costUnit",
            "type": "CostUnit",
            "format": ""
        },
        {
            "name": "transactionType",
            "baseName": "transactionType",
            "type": "BillingTransactionHistoryTransactionTypeEnum",
            "format": ""
        },
        {
            "name": "marketplaceAgreementId",
            "baseName": "marketplaceAgreementId",
            "type": "string",
            "format": ""
        },
        {
            "name": "marketplaceRefundId",
            "baseName": "marketplaceRefundId",
            "type": "string",
            "format": ""
        },
        {
            "name": "billingTime",
            "baseName": "billingTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BillingTransactionHistory.attributeTypeMap;
    }
    constructor() {
    }
}
export var BillingTransactionHistoryTransactionTypeEnum;
(function (BillingTransactionHistoryTransactionTypeEnum) {
    BillingTransactionHistoryTransactionTypeEnum["EmptyBillingTransaction"] = "EMPTY_BILLING_TRANSACTION";
    BillingTransactionHistoryTransactionTypeEnum["ContractSigned"] = "CONTRACT_SIGNED";
    BillingTransactionHistoryTransactionTypeEnum["CreditUsage"] = "CREDIT_USAGE";
    BillingTransactionHistoryTransactionTypeEnum["MarketplaceCharge"] = "MARKETPLACE_CHARGE";
    BillingTransactionHistoryTransactionTypeEnum["CreditUsageAndMarketplaceCharge"] = "CREDIT_USAGE_AND_MARKETPLACE_CHARGE";
    BillingTransactionHistoryTransactionTypeEnum["Refund"] = "REFUND";
    BillingTransactionHistoryTransactionTypeEnum["TransactionTypeUnspecified"] = "TRANSACTION_TYPE_UNSPECIFIED";
})(BillingTransactionHistoryTransactionTypeEnum || (BillingTransactionHistoryTransactionTypeEnum = {}));
